'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dofCheckbox = require('../dof-checkbox');

var _dofCheckbox2 = _interopRequireDefault(_dofCheckbox);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofCheckbox: _dofCheckbox2.default },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hasBorder: {
      type: Boolean,
      default: false
    },
    needShowTopBorder: {
      type: Boolean,
      default: false
    },
    needShowLastBottomBorder: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      checkedList: []
    };
  },
  created: function created() {
    var _this = this;

    var list = this.list;

    if (list && list.length > 0) {
      list.forEach(function (item) {
        item.checked && _this.checkedList.push(item.value);
      });
    }
    // console.log("checkbox-list 初始化已选项", this.checkedList)
  },

  methods: {
    dofCheckBoxItemChecked: function dofCheckBoxItemChecked(e) {
      // console.log("checkbox-list e",e)
      if (e.checked) {
        this.checkedList.push(e.value);
      } else {
        var index = this.checkedList.indexOf(e.value);
        this.checkedList.splice(index, 1);
      }
      this.$emit('dofCheckBoxListChecked', { checkedList: this.checkedList });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { DofCheckbox } from '../../index';


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-checkbox-list/index.vue
// module id = 313
// module chunks = 0 1